import React from "react";
import { cn } from "../../lib/utils";
import { Map as MapIcon, Plus } from "lucide-react";
import type { MapCustomMapsEmptyStateProps } from "../../contracts/map-custom-maps";

export function MapCustomMapsEmptyState({
  title,
  description,
  helperText,
  actions = [],
  onAction,
  className,
}: MapCustomMapsEmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center max-w-md mx-auto text-center py-12 px-6 bg-muted/30 rounded-2xl border border-dashed",
        className
      )}
    >
      <div className="w-16 h-16 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mb-6 shadow-sm ring-1 ring-primary/20">
        <MapIcon className="w-8 h-8" />
      </div>
      
      <h3 className="text-xl font-bold mb-3 text-foreground">
        {title}
      </h3>
      
      {description && (
        <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
          {description}
        </p>
      )}
      
      {helperText && (
        <p className="text-xs text-muted-foreground/60 mb-8 italic">
          {helperText}
        </p>
      )}

      {actions.length > 0 && (
        <div className="flex flex-col sm:flex-row items-center gap-3">
          {actions.map((action) => (
            <button
              key={action.id}
              onClick={() => onAction?.(action.id)}
              disabled={action.disabled}
              className={cn(
                "w-full sm:w-auto inline-flex items-center justify-center rounded-lg px-6 py-2.5 text-sm font-semibold transition-all shadow-sm ring-1",
                action.tone === "muted"
                  ? "bg-muted text-muted-foreground hover:bg-muted/80 ring-border"
                  : "bg-primary text-primary-foreground hover:bg-primary/90 ring-primary/20"
              )}
            >
              {action.id === "create" && <Plus className="w-4 h-4 mr-2" />}
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
